export default function teamCareurl() {
  const target = (process.env.REACT_APP_TARGET || "dev").trim();
  const resolveProductUrl = (product) => {
    if (target === "prod") {
      return `https://${product}.perceptionhealth.com/`;
    }

    if (target === "uat") {
      return `https://${product}-uat.perceptionhealth.com/`;
    }

    return `https://${product}-${target}.mi.huronconsultinggroup.com/`;
  };

  const careUrl = resolveProductUrl("care");
  const teamUrl = resolveProductUrl("team");

  return { careUrl, teamUrl };
}
